import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../../app/state";
import { selectGlobalSettings } from "../../../store/settingsStore/settingsSelectors";
import { useFormik } from "formik";
import { isEmpty } from "lodash/fp";
import { editGlobalSettings } from "../../../store/settingsStore/settingsRequests";
import HorizontalPanel from "../../../components/HorizontalPanel";
import { Toolbar } from "../../../app/components";
import { IconButton } from "@material-ui/core";
import SaveIcon from "@material-ui/icons/Save";
import ExportSettingsForm, { ExportSettingsValidationSchema } from "./ExportSettingsForm";

const ExportSettings = () => {
  const dispatch = useDispatch<AppDispatch>();
  const settings = useSelector(selectGlobalSettings);

  const settingsFormik = useFormik({
    initialValues: {
      exportDefaultUnits: settings?.exportDefaultUnits || 'MHz',
      exportEnumerationDivider: settings?.exportEnumerationDivider || ',',
      exportFieldDivider: settings?.exportFieldDivider || ';',
      exportDecimalDivider: settings?.exportDecimalDivider || '.',
      exportDecimalPlaceDigits: settings?.exportDecimalPlaceDigits || 2,
      exportFormatDate: settings?.exportFormatDate || 'DD.MM.YYYY',
    },
    onSubmit: () => {},
    validationSchema: ExportSettingsValidationSchema,
    enableReinitialize: true,
    validateOnChange: false,
    validateOnBlur: false,
  });

  const onSave = async () => {
    const errors = await settingsFormik.validateForm();
    if (isEmpty(errors)) {
      dispatch(editGlobalSettings(settingsFormik.values));
    }
  };

  return (
    <HorizontalPanel size={HorizontalPanel.SIZES.SMALL}>
      <HorizontalPanel size={HorizontalPanel.SIZES.SMALL}>
        <Toolbar title='Export/Reporting default settings'>
          <IconButton
            disabled={!settingsFormik.dirty}
            aria-label='save changes'
            color='secondary'
            size='small'
            onClick={onSave}
          >
            <SaveIcon />
          </IconButton>
        </Toolbar>
      </HorizontalPanel>
      <HorizontalPanel
        size={HorizontalPanel.SIZES.REST_SPACE}
      >
        <ExportSettingsForm settingsFormik={settingsFormik} />
      </HorizontalPanel>
    </HorizontalPanel>
  )
}

export default ExportSettings;